import React, { useState, useEffect } from 'react'
import { jump, template, loadXman } from '@src/utils'
import Trial from '@src/utils/trial'
import tab0 from '../assets/image/ad/tab0.png'
import tab1 from '../assets/image/ad/tab1.png'
import tab2 from '../assets/image/ad/tab2.png'
import mtab0 from '../assets/image/ad/m-tab0.png'
import mtab1 from '../assets/image/ad/m-tab1.png'
import mtab2 from '../assets/image/ad/m-tab2.png'
import Quotation from '@src/components/page/detail/edigest-quotation'
import { getMarketPlans, reportViewTimes } from '@src/api'
import { useIntl } from 'react-intl'
import { useMediaQuery } from 'react-responsive'
import './ad-apply.scss'

function AdApply () {
  const intl = useIntl()
  const isPc = useMediaQuery({ query: '(min-width: 798px)' })
  const t = (id) => {
    const message = intl.formatMessage({ id })
    return message
  }
  const prdCfg = [{
    name: t('anan_resp_edigest_prd_1') || 'ZA 人壽保',
    goodsId: 223035,
    feature: t('anan_resp_edigest_prd_feature_223035') || '結婚、生仔、買樓，加保依然免核保'
  }, {
    name: t('anan_resp_edigest_prd_2') || 'ZA 癌症保',
    goodsId: 223030,
    feature: t('anan_resp_edigest_prd_feature_223030') || '一筆過癌症保障, 覆蓋初期癌症'
  }, {
    name: t('anan_resp_edigest_prd_3') || 'ZA 心中保',
    goodsId: 223017,
    feature: t('anan_resp_edigest_prd_feature_223017') || '不需捆綁到其他疾病,保障從此隨你配搭'
  }]
  const tabs = prdCfg.map((item) => item.name)
  const bgs = isPc ? [tab0, tab1, tab2] : [mtab0, mtab1, mtab2]
  const productImages = [t('anan_resp_product_img_223035'), t('anan_resp_product_img_223030'), t('anan_resp_product_img_223017')]
  const [tab, setTab] = useState(0)
  const [productPlan, setProductPlan] = useState({})
  const [factors, setFactors] = useState()
  const [tabChanged, setTabChanged] = useState(false)
  const channel = 'ED'

  useEffect(() => {
    loadXman()
  }, [])

  useEffect(() => {
    handleMarketPlans(tab)
    reportViewTimes(channel)
  }, [])
  
  async function handleMarketPlans(tab) {
    const { goodsId } = prdCfg[tab]
    const res = await getMarketPlans(goodsId)
    if (res.success && res.value && res.value.plans) {
      const plan = res.value.plans[0]
      setProductPlan({
        goodsId,
        planId: plan?.goodPlanId,
        productPackageId: plan?.productPackageId,
        products: plan?.products
      })
    }
  }

  function handleDetail () {
    const { promotionCode, ...rest } = factors || {}
    // sessionStorage.set('calculateVals', rest)
    const { goodsId } = prdCfg[tab]
    Trial.saveCalItems(rest, goodsId)
    jump(`/productdetail?goodsId=${prdCfg[tab].goodsId}&channel=ED&pcode=${promotionCode}&goto=1`, true)
  }

  function changeTab(index) {
    handleMarketPlans(index)
    setTab(index)
    setTabChanged(true)
  }
  
  function changeQuotationFactors(factors) {
    setFactors(factors)
  }
  const termsPdf = t('anan_resp_edigest_terms_pdf')
  const termsCfg = t('anan_resp_edigest_terms') || '細則請閱讀 <a href={termsPdf} target="_blank">活動條款</a>'
  const tabStyle = tabChanged ? { backgroundImage: `url(${bgs[tab]})` } : {}
  const mobileBg = `#32cb9d url(${t('anan_resp_edigest_m_bg_img')}) no-repeat top left/contain`
  const pcBg = `url(${t('anan_resp_edigest_pc_bg_img_left')}) no-repeat 0 0, url(${t('anan_resp_edigest_pc_bg_img')}) no-repeat 100% 0/auto 1.85rem #32CB9D`
  const adBg = isPc ? pcBg : mobileBg
  return (
    <div className='ad-apply' style={{ background: adBg }}>
      <h1>{t('anan_resp_edigest_title') || 'ED x ZA Insure 幫你節省 30% 保費'}</h1>
      <p className='ad-tips' dangerouslySetInnerHTML={{ __html: t('anan_resp_edigest_tips') || '30 秒 Quote 價,<br /><em>新用户送 HOME+ HK$150 電子現金券</em>'}} />
      <p className='ad-terms' dangerouslySetInnerHTML={{ __html: template(termsCfg, { termsPdf }) }} />
      <div className='product-tabs' style={tabStyle}>
        {
          tabs.map((item, index) => {
            return (
              <div key={index} className={`tab ${index === tab ? 'active' : ''}`} onClick={() => changeTab(index)}>
                { item }
              </div>
            )
          })
        }
      </div>
      <div className='product'>
        <div className='quotation'>
          <Quotation t={t} productPlan={productPlan} onChangeFactors={changeQuotationFactors} isPc={isPc} channel={channel}/>
        </div>
        <div className='banner'>
          <p className='features'>{prdCfg[tab].feature}</p>
          <p className='more'><a onClick={handleDetail}>{t('anan_resp_edigest_prd_more') || '了解更多'}<i className='iconfont icona-Frame100' /></a></p>
          <img src={productImages[tab]} />
        </div>
        <p className='explanation'>{t('anan_resp_edigest_explanation') || '*新用戶是指完成指定步驟並成功註冊ZA Fam的用戶'}</p>
      </div>
    </div>
  )
}

export default AdApply